import React from 'react'

const MenuDesktop = () => {
  return (
    <nav id="" className="hidden lg:block font-basis font-bold text-gray-1 px-4">
    <ul className="flex">
      <a className="px-4" href="/#choose-style" id="design-box-link-js">Design a box</a>
      <li className="px-4">
        <a href="/" className="">
          Packlane Plus
          <span data-rotate="down" className=""></span>
        </a>
        <ul className="hidden">
          <a className="" href="/packlane-plus">Products and services </a>
          <a className="" href="/request-quote">Volume discounts</a>
        </ul>
      </li>
      <a className="px-4" href="/shiplane">Shiplane</a>
      <a className="px-4" href="/inspiration">Inspiration</a>
      <a className="px-4" href="/customers">Customers</a>
      <li className="px-4">
        <a href="/" className="">
          About
          <span data-rotate="down" className=""></span>
        </a>
        <ul className="hidden">
          <a className="" href="/about">Company</a>
          <a className="" href="/blog">Blog</a>
          <a className="" href="/faq">FAQ</a>
          <a className="" href="/contact">Contact</a>
        </ul>
      </li>
      <a className="px-4" href="/login">Log in</a>
      <a className="px-4" href="/signup">Sign up</a>
    </ul>
  </nav>

  )
}

export default MenuDesktop
